export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11786.63e9ceb9.jpg";